import { useEffect, useMemo } from "react";
import { useQuery, useMutation } from "react-query";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import _ from "lodash";

import { getDashboardNote, saveNote } from "@/api/Dashboard/dashboard";

import Fetching from "@/components/Fetching/Fetching";
import { datetimeToLocale, validRoles } from "@/services/Utils";

import classes from "./dashboard-notes.module.scss";

const DashboardNotes = () => {
	const userRoles = JSON.parse(localStorage.getItem("roles"));
	const isManager = validRoles(userRoles, ["administrador", "gerente_agricola"]);

	const { data, isLoading } = useQuery(["dashboard_notes"], () => getDashboardNote());

	const { mutate: handleSaveNote } = useMutation(saveNote, {
		onSuccess: () => {},
	});

	const delayedQuery = useMemo(
		() =>
			_.debounce((value) => {
				handleSaveNote({
					value,
				});
			}, 500),
		[handleSaveNote],
	);

	useEffect(() => {
		return () => {
			delayedQuery.cancel();
		};
	}, [delayedQuery]);

	const handleCKEditor = (event, editor) => {
		const data = editor.getData();
		delayedQuery(data);
	};

	if (!isManager) {
		return <></>;
	}

	return (
		<>
			{isLoading ? (
				<Fetching topMargin={"5em"} bottomMargin={"5em"} />
			) : (
				<>
					<div className={classes.notes} id="div-dashboard-note">
						<CKEditor
							editor={ClassicEditor}
							onChange={handleCKEditor}
							config={{
								licenseKey: "GPL",
								toolbar: ["heading", "|", "bold", "italic", "underline", "bulletedList", "numberedList", "link"],
								placeholder: "",
							}}
							data={data && data.notes ? data.notes : ""}
						/>
					</div>

					<div className={classes.notes_modification}>
						Última modificación {data && data.notes_last_edit ? datetimeToLocale(data.notes_last_edit) : ""}
					</div>
				</>
			)}
		</>
	);
};

export default DashboardNotes;
